/* oxlint-disable cf-web/no-barrel-file */
export { BaseCard, baseCardVariants } from './base-card'
export type { BaseCardProps } from './base-card'
export { BaseCardDemo } from './base-card.demo'
